module.exports = __webpack_public_path__ + "static/media/icon-close.5276b565.svg";